// Locked ids are cognitive search ids / real product ids, but items carry `id` in different id spaces.
export const isLockedItem = (item: any, lockedIds: Set<string>): boolean =>
  [item?.cognitiveSearchId, item?.id, item?.smartDocsDocumentId, item?.dataProductId].some(
    (id) => id !== undefined && id !== null && lockedIds.has(String(id))
  )
